import { MenuItem, Select } from "@outschool/backpack";
import { dayjs } from "@outschool/time";
import ldFlatMap from "lodash/flatMap";
import ldRange from "lodash/range";
import React from "react";

const HOURS = [12].concat(ldRange(1, 12));
const MINUTES = ["00", "15", "30", "45"];
const AMPM = ["am", "pm"];
const OPTION_LABELS = ldFlatMap(AMPM, ampm =>
  ldFlatMap(HOURS, hour => MINUTES.map(minute => `${hour}:${minute}${ampm}`)),
);
const OPTIONS = OPTION_LABELS.map(label => ({
  label,
  value: dayjs(label, "h:mma").format("HH:mm"),
}));

type TimeSelectInputProps = {
  // expected in format HH:mm
  value: string;
  onChange(value: string): void;
};

function TimeSelectInput({ value, onChange }: TimeSelectInputProps) {
  return (
    <Select
      value={value}
      onChange={e => onChange(e.target.value)}
      size="small"
      sx={{ width: "110px" }}
      MenuProps={{ sx: { maxHeight: "280px" } }}
    >
      {OPTIONS.map(option => (
        <MenuItem key={option.label} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
}

export default TimeSelectInput;
